// extracted by mini-css-extract-plugin
export default {"modifiers_container":"ProductModifiers_modifiers_container__6bYXt"};